var React = require('react');

function CircleArrowSmall (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2.5 5.61606C2.5 3.06705 4.47613 1.00068 6.9138 1.00068C8.39108 1.00068 9.69885 1.75957 10.5 2.92487","stroke":"#001D3B","strokeWidth":"2","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M11.5 6.38529C11.5 8.93429 9.52387 11.0007 7.0862 11.0007C5.60892 11.0007 4.30115 10.2418 3.49998 9.07647","stroke":"#001D3B","strokeWidth":"2","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M8.90039 3.3699H10.5004V1.7699","stroke":"#001D3B","strokeWidth":"2","strokeLinecap":"round","key":2}),React.createElement("path",{"d":"M5.09961 8.63145L3.49961 8.63145L3.49961 10.2314","stroke":"#001D3B","strokeWidth":"2","strokeLinecap":"round","key":3})]);
}

CircleArrowSmall.defaultProps = {"width":"13","height":"12","viewBox":"0 0 13 12","fill":"none"};

module.exports = CircleArrowSmall;

CircleArrowSmall.default = CircleArrowSmall;
